import React from "react";
import {
  StoplossType,
  StoplossTypeName,
  Frequencies,
  FrequencyValues,
  BotType,
  BotTypeName,
  TakeProfitTypeName,
  TakeProfitType,
  FrequenciesPro,
  FrequencyValuesPro
} from "../../../Const";
import {useSelector } from "react-redux";
import { Col, Row, Table } from "react-bootstrap";
import LeftRightForm from "../new-bot/modules/LeftRightForm";
import CommonBotSettings from "./CommonBotSettings";

const AdvanceBotSetting = (props) => {
  const { bot,t } = props;
  const isExitBot = bot.type==BotType.exit;
  const theme = useSelector((state) => state.settings.selected_theme);
  const tsls = bot.tsls || [];
  let stoploss = (bot.stop_loss || 0).toFixed(2) + "%";
  if (tsls.length) {
    stoploss =
      tsls[0].sl_type === StoplossType.fixedTsl
        ? StoplossTypeName.fixedTsl
        : StoplossTypeName.variableTsl;
  }
  const tps = bot.tps || [];
  let takeProfit = `${(bot.profit || 0).toFixed(2)}${bot.type === BotType.price ? "" : "%"}`;
  if (tps.length) {
    takeProfit =
    tps[0].tp_type === TakeProfitType.fixedTP
        ? TakeProfitTypeName.fixedTP
        : TakeProfitTypeName.variableTP;
  }
  const exchangePair = bot.exchange_pair || {};
  const exchange = exchangePair.exchange || {};
  const pair = exchangePair.pair || {};
  const indicators = bot.bot_indicators || [];
  const defaultPriceEntryCondition = bot.strategy == "Short" ? "gte" : "lte";
  const priceEntryCondition = bot.entry_price_condition || defaultPriceEntryCondition;
  const priceEntryLabel = priceEntryCondition == "gte"
    ? (bot.strategy == "Short" ? t("sell-when-price-greater-equal") : t("buy-when-price-greater-equal"))
    : (bot.strategy == "Short" ? t("sell-when-price-less-equal") : t("buy-when-price-less-equal"));
  const entryIndicators = bot.type == BotType.price
    ? `${priceEntryLabel} ${(bot.entry_price || 0).toFixed(2)} ${pair.to || ""}`.trim()
    :
    indicators &&
    indicators
      .filter((item) => item.type == "entry")
      .map((item) => item.name)
      .join(", ");
  const exitIndicators =
    indicators &&
    indicators
      .filter((item) => item.type == "exit")
      .map((item) => item.name)
      .join(", ");
  return (
    <div className="col-lg-6 col-md-6">
    <div className="bot-detail-left">
      <div className="bot-detail-left-header">
        <label>
          <img src="/images/overview-icon.svg" alt=""/>
          Overview
        </label>
        <label>
          <img src={exchange.image} alt=""/>
          {exchange.name}
        </label>
      </div>
      <div className="bot-detail-left-body">
        <div className="row">
          <div className="col-6">
            <div className="bdol-item">
              <span>{t("pair")}</span>
              <h6>{pair && `${pair.from}/${pair.to}`}</h6>
            </div>
          </div>
         
          <CommonBotSettings bot={bot} t={t}></CommonBotSettings>
          {!isExitBot &&<div className="col-6">
            <div className="bdol-item" >
              <span>{t("entry-indicators")}</span>
              <h6>{entryIndicators}</h6>
            </div>
          </div>}
          <div className="col-6">
            <div className="bdol-item">
              <span>{t("exit-indicators")}</span>
              <h6>{exitIndicators}</h6>
            </div>
          </div>
          <div className="col-6">
            <div className="bdol-item">
              <span>{t("tp")}</span>
              <h6>{bot && takeProfit}</h6>
            </div>
          </div>
          <div className="col-6">
            <div className="bdol-item">
              <span>{t("stoploss")}</span>
              <h6>{stoploss}</h6>
            </div>
          </div>
          <div className="col-6">
            <div className="bdol-item">
              <span>{t("Extended Trading Hour")}</span>
              <h6>{bot && parseInt(bot.extended_trading_hour)?"Yes":"No"}</h6>
            </div>
          </div>
          <div className="col-6">
            <div className="bdol-item">
              <span>{t("Enable 24 Hour")}</span>
              <h6>{((bot && parseInt(bot.trading_hour_247)) || exchange && exchange.id===6 )?"Yes":"No"}</h6>
            </div>
          </div>
          {/* <div className="col-6">
            <div className="bdol-item">
              <span>{t("24 Hours Trading")}</span>
              <h6>{bot && parseInt(bot.trading_hour_247)?"Yes":"No"}</h6>
            </div>
          </div> */}
          <div className="col-6">
            <div className="bdol-item">
              <span>{t("auto-close-trading")}</span>
              <h6>{bot && parseInt(bot.end_day_auto_close)?"Yes":"No"}</h6>
            </div>
          </div>
          <div className="col-6">
            <div className="bdol-item">
              <span>{t("bo-limit")}</span>
              <h6>{bot && bot.base_order_percentage} %</h6>
            </div>
          </div>
          <div className="col-6">
            <div className="bdol-item">
              <span>{t("Extra Order")}</span>
              <h6>{bot && bot.extra_order_percentage} %</h6>
            </div>
          </div>
          <div className="col-6">
            <div className="bdol-item">
              <span>{t("min-price-gap-extra")}</span>
              <h6>{bot && bot.extra_price_gap_min} %</h6>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
      
  );
};

export default AdvanceBotSetting;
